export abstract class FormWidget {
    public abstract name: string;

    public getName() {
        return this.name;
    }

    public abstract isFormValid(): boolean;

    public abstract scrollIntoErrorView(): void;
}
